import Model from './Model';

export default class Admin extends Model {
  resource() {
    return 'admins';
  }
}
